import React from "react";
import styled from "styled-components";
import { ReleaseDetailsFormProps } from "../types";
import {FormattedMessage} from "react-intl";

const ReleaseDetailsForm: React.FC<ReleaseDetailsFormProps> = ({
  title,
  version,
  label,
  release_date,
  original_release_date,
  genres,
  pline_value,
  cline_value,
}) => {
  const truncateText = (value: any, max = 20) => {
    const s = String(value ?? "");
    if (s.length <= max) return s;
    return `${s.slice(0, max)}...`;
  };
  return (
    <Container>
      <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.ReleaseDetails"
            defaultMessage="Release details"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.ReleaseTitle"
                defaultMessage="Release title"
              />
            </FieldLabel>
            <FieldValue>{truncateText(title, 20)}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.ReleaseVersion"
                defaultMessage="Release version"
              />
            </FieldLabel>
            <FieldValue>{truncateText(version, 20)}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.Label"
                defaultMessage="Label"
              />
            </FieldLabel>
            <FieldValue>{label?.name}</FieldValue>
          </Field>
        </FieldGroup>
      </Section>

       <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.Copyright"
            defaultMessage="Copyright"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.PLine"
                defaultMessage="PLine"
              />
            </FieldLabel>
            <FieldValue>
              {String(pline_value ?? "").trim() || "—"}
            </FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.CLine"
                defaultMessage="CLine"
              />
            </FieldLabel>
            <FieldValue>
              {String(cline_value ?? "").trim() || "—"}
            </FieldValue>
          </Field>
        </FieldGroup>
      </Section>

      <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.ReleaseDate"
            defaultMessage="Release date"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.ReleaseDate"
                defaultMessage="Release date"
              />
            </FieldLabel>
            <FieldValue>{release_date}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.OriginalReleaseDate"
                defaultMessage="Original release date"
              />
            </FieldLabel>
            <FieldValue>{original_release_date}</FieldValue>
          </Field>
        </FieldGroup>
      </Section>

      <Section>
        <SectionTitle>
          <FormattedMessage
            id="ReleaseDetails.ReleaseDetailsForm.Genre"
            defaultMessage="Genre"
          />
        </SectionTitle>
        <FieldGroup>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.MainGenre"
                defaultMessage="Main genre"
              />
            </FieldLabel>
            <FieldValue>
              {(genres ?? [])
                .filter((g: any) => g?.is_primary === true || g?.is_primary === 1 || g?.is_primary === "1")
                .map((g: any, index: number, arr: any[]) => (
                  <span key={g?.id ?? index}>{g.name}{arr.length - 1 !== index ? ", " : ""}</span>
                ))}
            </FieldValue>
          </Field>
          <Field>
            <FieldLabel>
              <FormattedMessage
                id="ReleaseDetails.ReleaseDetailsForm.AdditionalGenres"
                defaultMessage="Additional genres"
              />
            </FieldLabel>
            <FieldValue>
              {(genres ?? [])
                .filter((g: any) => !(g?.is_primary === true || g?.is_primary === 1 || g?.is_primary === "1"))
                .map((g: any, index: number, arr: any[]) => (
                  <span key={g?.id ?? index}>{g.name}{arr.length - 1 !== index ? ", " : ""}</span>
                ))}
            </FieldValue>
          </Field>
        </FieldGroup>
      </Section>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Section = styled.div``;

const SectionTitle = styled.h3`
  margin: 14px 0 12px 0;
  font-weight: 600;
  font-size: 16px;
`;

const FieldGroup = styled.div`
  display: flex;
  gap: 20px;

  /* Mobile: stack fields to avoid pushing content off-screen (e.g. Label) */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;

  @media (max-width: 768px) {
    min-width: 0;
    width: 100%;
  }
`;

const FieldLabel = styled.span`
 
  color: #888;
  font-size: 14px;
`;

const FieldValue = styled.span`
  color: #000;
  font-weight: 500;
  font-size: 14px;
`;

export default ReleaseDetailsForm;
